export default {
  callingAPI: false,
  searching: '',
  serverURI: 'http://10.110.1.136:8080',
  user: null,
  token: null,
  flag: 'br'
}



// WEBPACK FOOTER //
// ./src/store/state.js